export default "__VITE_ASSET__0b45b6c2__"